export const BEFORE_TIMEOUT = 200;
export const LINE_HEIGHT = 1.2;
